import { ApplicationInsights, ITelemetryItem } from "@microsoft/applicationinsights-web";

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;
const isPlaceholderConnectionString =
  !connectionString ||
  connectionString.includes("YOUR_KEY") ||
  connectionString.includes("YOUR_REGION") ||
  connectionString.includes("your_region");

let appInsights: ApplicationInsights | null = null;

if (!isPlaceholderConnectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false,
      disableAjaxTracking: false,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((item: ITelemetryItem) => {
    item.tags = item.tags || {};
    item.tags["ai.cloud.role"] = "qft-frontend";
  });

  window.addEventListener("error", (event) => {
    trackException(event.error || new Error(event.message), {
      source: "window.error",
      filename: event.filename || "unknown",
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    let reason: Error;
    if (event.reason instanceof Error) {
      reason = event.reason;
    } else if (typeof event.reason === "string") {
      reason = new Error(event.reason);
    } else {
      reason = new Error("Unhandled promise rejection");
    }
    trackException(reason, { source: "window.unhandledrejection" });
  });
} else if (connectionString) {
  console.info("Application Insights disabled: placeholder connection string detected.");
}

export function isTelemetryEnabled(): boolean {
  return !!appInsights;
}

export function trackPageView(name: string, uri?: string): void {
  if (!appInsights) return;
  appInsights.trackPageView({ name, uri });
}

export function trackEvent(
  name: string,
  properties?: Record<string, string>,
  measurements?: Record<string, number>
): void {
  if (!appInsights) return;
  appInsights.trackEvent({ name }, properties, measurements);
}

export function trackMetric(name: string, average: number, properties?: Record<string, string>): void {
  if (!appInsights) return;
  appInsights.trackMetric({ name, average }, properties);
}

export function trackException(error: unknown, properties?: Record<string, string>): void {
  if (!appInsights) return;
  let exception: Error;
  if (error instanceof Error) {
    exception = error;
  } else if (typeof error === "string") {
    exception = new Error(error);
  } else {
    exception = new Error("Unknown frontend exception");
  }
  appInsights.trackException({ exception, properties });
}
